import { Dashboard } from './../../shared/interceptors/token.interceptors';
import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  // Variable que se utiliza en el componente Head para mostrar o no cosas
  // POSIBLEMENTE SE REMUEVA
  public isLogged: boolean; // 0: no loggeado, 1: loggeado

  public headers: HttpHeaders = new HttpHeaders({}).set(Dashboard, 'Dashboard');

  constructor(public _http: HttpClient, public router: Router) {}

  /**
   * Tipos de usuario de la plataforma
   * Se trae la lista de tipos del servidor
   */
  tipoUsuario() {
    return this._http.get(environment.login_tipos_usuario);
  }

  // Login //
  loginUsuario(loginForm): Observable<any> {
    return this._http.post(environment.login_login, loginForm);
  }
  /**
   * Paso 1 - Validación cuenta
   * Envío del código al correo para confirmar la verificación de la cuenta
   */
  sendVerificationCode(codeForm) {
    return this._http.post(environment.login_validacion.envio_codigo_primera_vez, codeForm);
  }

  /**
   * Paso 2 - Validación código
   * Envío del código a la plataforma para validar cuenta
   */
  sendMailCode(mailForm) {
    return this._http.post(environment.login_validacion.codigo_validacion_correo, mailForm);
  }

  /**
   * Paso 3 - Cambio de contraseña
   * El usuario por defecto tiene la contraseña como 123456
   * Se le pedirá cambiar la contraseña
   */
  changePasswordUserVerified(passwordForm) {
    return this._http.post(environment.login_validacion.cambio_password_usuario_verificado, passwordForm);
  }
  // RECUPERACIÓN DE CONTRASEÑA
  /**
   * Paso 1
   * Envio del formulario de tipo de usuario y correo para enviar el código al correo del usuario
   */
  sendTypeUserForm(form) {
    return this._http.post(environment.recover_password.recuperar_contrasena, form);
  }

  /**
   * Paso 2
   * Envio del código y contraseña
   */
  sendChangePassword(form) {
    return this._http.post(environment.recover_password.verificacion_codigo_contrasena, form);
  }

  // Handler de errores
  errorHandler(error: HttpErrorResponse) {
    let errorMessage;

    if (error.error instanceof ErrorEvent) {
      console.log(error);
      // client-side error
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }

    return throwError(error);
  }
}
